(() => {
  const replacements = [
    [/\bSAR\b/g, '⃁'],
    [/ر\.س/g, '⃁'],
    [/ريال سعودي/g, '⃁'],
    [/ريال/g, '⃁']
  ];
  const skipTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'NOSCRIPT']);
  const replaceText = (node) => {
    if (!node || !node.nodeValue) return;
    let value = node.nodeValue;
    let next = value;
    replacements.forEach(([pattern, replacement]) => { next = next.replace(pattern, replacement); });
    if (next !== value) node.nodeValue = next;
  };
  const walk = (root) => {
    if (!root || skipTags.has(root.nodeName)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || skipTags.has(parent.nodeName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceText);
  };
  const init = () => {
    walk(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) replaceText(node);
          else if (node.nodeType === Node.ELEMENT_NODE) walk(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
